import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  getCurrentSubscription(): Observable<any> {
    return this.http.get<any>(this.baseUrl + `/subscription`);
  }

  cancelCurrentSubscription(): Observable<any> {
    return this.http.post<any>(this.baseUrl + `/subscription/cancel`, {});
  }
}
